module.exports = __webpack_public_path__ + "static/media/suit-heart.0e013b9f.png";